/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'report': {
    width: 16,
    height: 16,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M960 0a64 64 0 0164 64v832a128 128 0 01-128 128H128A128 128 0 010 896V368a64 64 0 0164-64h256V64a64 64 0 0164-64h576zM320 400H96v496a32 32 0 0026.24 31.488L128 928h192V400zM928 96H416v208h.576l-.064 624H896a32 32 0 0031.488-26.24L928 896V96zm-96 416v96H512v-96h320zm0-256v96H512v-96h320z"/>'
  }
})
